// vs 对战等待页面
import React, {useContext, useEffect, useState} from "react";
import './VSPlayerWaitingPage.css'
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";
import {PageEnum, PageProps} from "../../../../types/IPage.ts";
import BattleLinkDialog from "../BattleLink/BattleLinkDialog.tsx";
import Countdown from "../../../../components/CountDown/CountDown.tsx";
import {apiService} from "../../../../common/utils/http/api-service.ts";
import {IVSPlayerPageProps} from "../../../../types/IVSPlayer.ts";
import {GAEvents} from "../../../../common/utils/GA4/GAEvents.ts";

const VSPlayerWaitingPage: React.FC<PageProps & IVSPlayerPageProps> = ({switchPage, vsPlayerInfo, setVsPlayerInfo}) => {

    // 主题全局管理器
    const {imgUrls} = useContext(ThemeContext);
    // 是否显示battle link 弹窗
    const [showBattleLink, setShowBattleLink] = useState<boolean>(false);

    useEffect(() => {
        // GA埋点
        GAEvents.createMatchStart()
    }, []);

    // 轮询房间是否有人进来
    const checkIfPlayerInRoom = async () => {
        if(!vsPlayerInfo?.id) return;
        const response = await apiService.getInvitedPlayerStatus(vsPlayerInfo?.id);
        if (response.code === 200){
            if(setVsPlayerInfo) {
                setVsPlayerInfo(response.data)
            }
            // 跳转到PK动效界面
            goToVsPlayerShockingPage();
        }
    }

    // 直接进入游戏界面
    const startGame = () => {
        // GA埋点
        GAEvents.createMatchLinkClickStart()

        switchPage(PageEnum.VS_PLAYER_GAME_PAGE)
    }

    // 显示battle link弹窗
    const showBattleLinkDialog = () => {
        // GA埋点
        GAEvents.createMatchLinkClickInvite()

        setShowBattleLink(true)
    }

    // 跳转到闪电过渡页面
    const goToVsPlayerShockingPage = () => {
        switchPage(PageEnum.VS_PLAYER_SHOCK_PAGE)
    }

    // 返回vs player 主页
    const backToVSPlayerHomePage = () => {
        switchPage(PageEnum.VS_PLAYER_HOME)
    }

    return (
        <div>
            <div className="vs-player-waiting-bg-color"/>
            <div className="common-page-background-img" style={{backgroundImage: `url(${imgUrls.rectangleIcon})`}}/>
            <div className="vs-player-waiting-bg-color-white"/>
            {/*顶部logo*/}
            <div className="display-flex-column">
                {/*logo*/}
                <img className="width-66 height-66 margin-top-66 margin-left-right-auto"
                     src={imgUrls.vsPlayWaitingTopIcon} alt="pic"/>
                {/*标题*/}
                <div
                    className="margin-top-14 height-48 my-roboto-bold color-white font-size-40 display-flex-row display-flex-align-items-center display-flex-justify-content-center">VS
                    Player
                </div>
                {/*card*/}
                <div
                    className="display-flex-column margin-top-27 height-236 width-320 border-radius-10 vs-player-waiting-card-bg">
                    <div className="margin-top-13 color-white my-roboto-bold font-size-16 text-center">WAITING</div>
                    <div className="margin-top-10 vs-player-waiting-light-liner"/>
                    {/*时钟图标*/}
                    <img className="margin-top-20 height-26 width-26 margin-left-right-auto"
                         src={imgUrls.vsPlayWaitingClockIcon} alt="pic"/>
                    {/*倒计时时间*/}
                    <Countdown className="margin-top-10 font-size-42 my-roboto-bold color-white text-center"
                               onTick={checkIfPlayerInRoom}
                               onCountdownEnd={startGame}
                               startCount={600} interval={1000}/>
                    {/*邀请按钮*/}
                    <div onClick={showBattleLinkDialog}
                         className="margin-top-27 display-flex-row bg-color-white-20-percent width-290 height-43 border-radius-5 margin-left-right-auto display-flex-align-items-center display-flex-justify-content-center">
                        <img className="height-21 width-21" alt="pic" src={imgUrls.vsPlayWaitingPersonAddIcon}/>
                        <div className="margin-left-6 color-white my-roboto-medium font-size-16">Invite</div>
                    </div>
                </div>
                {/*底部按钮*/}
                <div className="display-flex-row height-100-percent width-320 display-flex-space-between margin-top-80">
                    <div onClick={backToVSPlayerHomePage}
                         className="font-size-16 color-blue my-roboto-medium border-radius-5 height-43 width-156 bg-color-white display-flex-row display-flex-align-items-center display-flex-justify-content-center">Cancel
                    </div>
                    <div onClick={startGame}
                         className="font-size-16 color-white my-roboto-medium border-radius-5 height-43 width-156 vs-player-waiting-start-btn-bg display-flex-row display-flex-align-items-center display-flex-justify-content-center">Start
                    </div>
                </div>
            </div>
            <BattleLinkDialog isOpen={showBattleLink}
                              onClose={() => setShowBattleLink(false)}
                              isShowInWaitingPage={true}
                              roomId={vsPlayerInfo?.id}
                              switchPage={switchPage}/>
        </div>
    );
};

export default VSPlayerWaitingPage;